import { useState, useCallback } from "react";

export const useExpandableDescription = (description, maxLength = 300) => {
  const [showFullDescription, setShowFullDescription] = useState(false);

  // ✅ stable reference
  const setShowFull = useCallback((val) => {
    setShowFullDescription(val);
  }, []);

  const isLong = description?.length > maxLength;

  const displayedDescription = showFullDescription
    ? description
    : (description || "").slice(0, maxLength) + (isLong ? "..." : "");

  return {
    showFullDescription,
    setShowFullDescription: setShowFull,
    displayedDescription,
    isLong,
  };
};